import { blipWebsocketHostName, messaginghubWebsocketHostName, blipWebsocketHostNameTenant, aiAgentsSettingsSource, } from 'app.constants';
import { messaginghubWebsocketHostNameTenant } from 'app.constants';
export class AiAgentsController {
    static $inject = ['LoadingService', 'TranslateService', 'application', 'AccountService2'];
    constructor(LoadingService, TranslateService, application, AccountService2) {
        this.LoadingService = LoadingService;
        this.TranslateService = TranslateService;
        this.application = application;
        this.AccountService2 = AccountService2;
        this.LoadingService.startLoading();
        const setProps = async () => {
            const account = await this.AccountService2.me();
            this.language = this.TranslateService.getCurrentLanguage();
            this.ownerIdentity = this.application.shortName;
            this.webSocketParams = {
                messaginghubWebsocketHostNameTenant,
                messaginghubWebsocketHostName,
                blipWebsocketHostName,
                blipWebsocketHostNameTenant,
            };
            this.LoadingService.stopLoading();
            this.settingsSource = aiAgentsSettingsSource;
            this.user = account.identity;
        };
        setProps();
    }
}
AiAgentsController.$inject = ['LoadingService', 'TranslateService', 'application', 'AccountService2'];
